import { ActivityLog } from '@bark/bark-core';
import { BarkMessengerV11 } from '../components/legacy-bark-messenger/bark-messenger-v11';

export default async function () {
	const activityLog = new ActivityLog('buyer');
	const bm = BarkMessengerV11();

	activityLog.load($('.messenger-container').attr('id'));
	activityLog.render();

	bm.messengerEvents.on(['buyer_response_action', 'buyer_sent_email'], function () {
		activityLog.redraw();
	});
}
